import { render, staticRenderFns } from "./ApprovalEntries.vue?vue&type=template&id=644cdd34&scoped=true"
import script from "./ApprovalEntries.vue?vue&type=script&lang=js"
export * from "./ApprovalEntries.vue?vue&type=script&lang=js"
import style0 from "./ApprovalEntries.vue?vue&type=style&index=0&id=644cdd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644cdd34",
  null
  
)

export default component.exports